import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import React from 'react';
import { Flex } from '@magnetic/flex';
import MapCompass from '../../../../../assets/svgs/map-compass';
import Close from '../../../../../assets/svgs/close-svg';
import { useTranslation } from 'react-i18next';
import { getLocation } from '../../../redux/spaces-slice';
import { useSelector } from 'react-redux';
import { getFloorNumberIdMap, getFloorShortNameByNumber } from '../../util';
const Modal = styled.div `
  background-color: #000;
  height: 100vh;
  opacity: 1;
  position: fixed;
  z-index: 9999999999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.7);
  display: flex !important;
`;
const ModalContent = styled(Flex) `
  background: #1d2023;
  width: 64vw;
  height: 22vw;
  margin: auto;
  /* 'Sora VF' (not plain 'Sora') so font-weight actually varies: the base
     'Sora' face is pinned to normal and clamps all weights to 400. */
  font-family: 'Sora VF';
  font-weight: 100;
  border-radius: 0.6vw;
  padding: 1vw;
  font-size: 2vw;
`;
const Text = styled(Flex) `
  font-family: ${(props) => props.fontFamily};
  font-size: ${(props) => props.fontSize};
  color: ${(props) => props.color};
  background: ${(props) => props.background};
  padding: ${(props) => props.padding};
  margin: ${(props) => props.margin};
`;
const GoButton = styled.div `
  background: linear-gradient(180deg, #1d7ff3 0%, #113d7d 100%);
  height: fit-content;
  width: fit-content;
  padding: 0.4vw;
  border-radius: 0.4vw;
  cursor: pointer;
  font-size: 1.4vw;
  display: flex;
  align-items: center;
  gap: 0.2vw;
  line-height: 1;
`;
export const SwitchFloorPopup = ({ name, floorNumber, selectFloor, onClose, isPOI, }) => {
    const { t } = useTranslation();
    const locationData = useSelector(getLocation);
    const floorNumberIdMap = getFloorNumberIdMap(locationData);
    const floorLocationId = floorNumberIdMap[Number(floorNumber)];
    const floorShortName = getFloorShortNameByNumber(locationData, floorNumber);
    return (_jsx(Modal, { children: _jsxs(ModalContent, Object.assign({ direction: "vertical" }, { children: [_jsxs(Flex, Object.assign({ justify: isPOI ? 'end' : 'space-between' }, { children: [!isPOI && (_jsx(Text, Object.assign({ margin: "0.4vw 0vw", style: { fontWeight: 100 } }, { children: t('floor.switch-floor-popup.label-1') }))), _jsx(Close, { onClose: onClose })] })), _jsx(Text, Object.assign({ margin: "0.4vw 0vw", style: { fontWeight: 700 } }, { children: name })), _jsx(Text, Object.assign({ margin: "0.4vw 0vw", style: { fontWeight: 100 } }, { children: t('floor.switch-floor-popup.label-2') })), _jsxs(Text, Object.assign({ margin: "3.2vw 0vw", style: { fontWeight: 100 } }, { children: [t('floor.switch-floor-popup.label-3'), _jsxs(Text, Object.assign({ as: "span", style: { fontWeight: 700 } }, { children: ["\u00A0", floorShortName] })), "?"] })), _jsx(Flex, Object.assign({ justify: "end" }, { children: _jsxs(GoButton, Object.assign({ onClick: () => {
                            selectFloor(floorLocationId);
                        } }, { children: [_jsx(Flex, Object.assign({ align: "center" }, { children: _jsx(MapCompass, {}) })), t('floor.switch-floor-popup.go-to-floor'), " ", floorShortName] })) }))] })) }));
};
